import {
  GetProgramConfigurationType,
  UpdateProgramConfigurationType,
} from '../../utils/type';
import { ApiMessage, ApiResponseHandler } from '../ApiResponseHandler';
import ThomApiClient from '../ThomApiClient';

export const getProgramConfigurationApi = async (id: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<GetProgramConfigurationType>(
      `program_configuration?id=${id}`,
    ),
  );
};

export const editOrAddProgramConfiigurationApi = async (
  id: string,
  requestBody: UpdateProgramConfigurationType,
): Promise<ApiMessage> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<
      UpdateProgramConfigurationType,
      ApiMessage
    >(`program_configuration?id=${id}`, requestBody),
  );
};
